// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2NXJJ","log":"ModalInventoryLogs_log__1u8pv","date":"ModalInventoryLogs_date__DBoFR","userName":"ModalInventoryLogs_userName__RIcZN"};